import { compact } from '@quromedical/utils';
import type { Field } from 'components/types';
import type { Fetcher } from 'design-system';
import { ampathTestFetcher } from 'integration';
import { strings } from 'strings';

import type { FormData, TestType } from './types';

export const createFields = (
  testType: TestType,
  generalPractitioners: Fetcher<string>,
): Field<FormData>[] => {
  const specialOrder = testType === 'special';
  const fields: (Field<FormData> | undefined)[] = [
    {
      subfields: [
        {
          type: 'radio-group',
          key: 'testType',
          label: strings.PathologyRequestTestTypeLabel,
          options: [
            {
              display: strings.AmpathRequestTestTypeNormalOption,
              value: 'normal',
            },
            {
              display: strings.AmpathRequestTestTypeSpecialOption,
              value: 'special',
            },
          ],
        },

        {
          key: 'sampleDateTime',
          type: 'date-component',
          label: strings.PathologySampleDateTimeLabel,
          maskType: 'datetime',
        },
      ],
    },
    {
      subfields: [
        {
          key: 'testCodes',
          type: 'combobox-multiple',
          searchable: true,
          label: specialOrder
            ? strings.AmpathRequestTestsSpecialLabel
            : strings.PathologyRequestTestsNormalLabel,
          returnFullOption: false,
          fetcher: ampathTestFetcher({ specialOrder }),
        },
      ],
    },
    {
      subfields: [
        {
          key: 'copyDoctors',
          type: 'combobox-multiple',
          searchable: true,
          label: strings.PathologyCopyDoctorsLabel,
          returnFullOption: false,
          fetcher: generalPractitioners,
        },
      ],
    },
    {
      subfields: [
        {
          key: 'comment',
          type: 'text-box',
          label: strings.PathologyCommentLabel,
          multiline: true,
        },
      ],
    },
  ];

  return compact(fields);
};

export const initialValues: Partial<FormData> = { testType: 'normal' };
